import React, { Component } from 'react';
import cn from 'classnames';
import AngleDown from 'react-icons/lib/fa/angle-down';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const getVariants = (t) => ({
  prkng: {
    param: 'prkng',
    key: 'parking',
    text: t('components.header.filtersBar.filters.advantages.parking'),
    event: 'Web_Filters_Parking',
  },
  elvtr: {
    param: 'elvtr',
    key: 'elevator',
    text: t('components.header.filtersBar.filters.advantages.elevator'),
    event: 'Web_Filters_Recreation_Elevator',
  },
  cncrg: {
    param: 'cncrg',
    key: 'concierge',
    text: t('components.header.filtersBar.filters.advantages.concierge'),
    event: 'Web_Filters_Concierge',
  },
  chldrn: {
    param: 'chldrn',
    key: 'children_area',
    text: t('components.header.filtersBar.filters.advantages.childrenArea'),
    event: 'Web_Filters_Children_Playground',
  },
  rcrtzn: {
    param: 'rcrtzn',
    key: 'recreation_zone',
    text: t('components.header.filtersBar.filters.advantages.recreationZone'),
    event: 'Web_Filters_Recreation_Area',
  },
  pool: {
    param: 'pool',
    key: 'pool',
    text: t('components.header.filtersBar.filters.advantages.pool'),
    event: 'Web_Filters_Swimming_Pool',
  },
  housetrr: {
    param: 'housetrr',
    key: 'houseTerritory',
    text: t('components.header.filtersBar.filters.advantages.houseTerritory'),
    event: 'Web_Filters_House_Territory',
  },
  spa: {
    param: 'spa',
    key: 'spa',
    text: t('components.header.filtersBar.filters.advantages.spa'),
    event: 'Web_Filters_SPA',
  },
  cctv: {
    param: 'cctv_surveillance',
    key: 'cctv_surveillance',
    text: t('components.header.filtersBar.filters.advantages.cctv'),
    event: 'Web_Filters_CCTV',
  },
  commerc: {
    param: 'commerc',
    key: 'commercial_property',
    text: t('components.header.filtersBar.filters.advantages.commercialProperty'),
    event: 'Web_Filters_Commercial_Property',
  },
  kpp: {
    param: 'kpp',
    key: 'kpp',
    text: t('components.header.filtersBar.filters.advantages.kpp'),
    event: 'Web_Filters_KPP',
  },
  wlns: {
    param: 'wlns',
    key: 'is_wellness_building',
    text: t('components.header.filtersBar.filters.advantages.wellnessBuilding'),
    event: 'Web_Filters_Wellness_Building',
  },
  beach: {
    param: 'beach',
    key: 'is_beach',
    text: t('components.header.filtersBar.filters.advantages.beach'),
    event: 'Web_Filters_Beach',
  },
  walk: {
    param: 'walk',
    key: ' is_walking_area',
    text: t('components.header.filtersBar.filters.advantages.walkingArea'),
    event: 'Web_Filters_Walking_Area',
  },
  rstrnt: {
    param: 'rstrnt',
    key: 'restaurant',
    text: t('components.header.filtersBar.filters.advantages.restaurant'),
    event: 'Web_Filters_Restaurant',
  },
  sport: {
    param: 'sport',
    key: 'sport_area',
    text: t('components.header.filtersBar.filters.advantages.sportArea'),
    event: 'Web_Filters_Sport_Area',
  },
  roof: {
    param: 'roof',
    key: 'is_operated_roof',
    text: t('components.header.filtersBar.filters.advantages.operatedRoof'),
    event: 'Web_Filters_Operated_Roof',
  },
  zbbq: {
    param: 'zbbq',
    key: 'zone_bbq',
    text: t('components.header.filtersBar.filters.advantages.zbbq'),
    event: 'Web_Filters_Zone_Bbq',
  },
  nw: {
    param: 'nw',
    key: 'new',
    text: t('components.header.filtersBar.filters.advantages.new'),
    event: 'Web_Filters_New',
  },
});

const checkIsOnePropDefined = (arr) => arr.length > 0;

const countDefinedProps = (arr) => arr.length;

export const parseSearch = (search, t) => {
  const { advantages } = search;
  if (!advantages) {
    return { advantages: [] };
  }
  const keys = advantages.split(',');
  const variants = getVariants(t);
  return {
    advantages: Object.keys(variants).reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.param)) {
        prev.push(variant.key);
      }
      return prev;
    }, []),
  };
};

export const compileSearch = (data, t) => {
  const { advantages: keys } = data;
  if (!keys.length) {
    return { advantages: undefined };
  }
  const variants = getVariants(t);

  return {
    advantages:
      Object.keys(variants)
        .reduce((prev, cur) => {
          const variant = variants[cur];
          if (keys.includes(variant.key)) {
            prev.push(variant.param);
          }
          return prev;
        }, [])
        .join(',') || undefined,
  };
};

export const compileRequest = (data) => {
  const { advantages } = data;
  return { advantages: advantages.length ? advantages : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search, i18n.t));

class Advantages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
  }

  handleClearClick(e) {
    e.stopPropagation();
    const { dropdownData, mode, profile, objectType, t } = this.props;
    const data = { advantages: [] };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);

    trackGA(
      gaEvent.filterClearButtonsClick({
        eventContent: 'eshchyo',
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData, mode, objectType, profile, t } = this.props;
    const { advantages: keys } = parseSearch(search, t);
    const advantages = [...keys];
    const variants = getVariants(t);

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    const variant = variants[Object.keys(variants).find((v) => variants[v].key === key)];
    const variantName = variant ? variant.text : 'Unknown variant';
    const isChecked = add ? 'on' : 'off';

    trackGA(
      gaEvent.filterCheckboxesClick({
        eventContent: [variantName, ` | ${isChecked}`],
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );

    if (advantages.includes(key) !== add) {
      if (add) {
        advantages.push(key);
      } else {
        advantages.splice(advantages.indexOf(key), 1);
      }
    }

    const data = { advantages };
    const compiledSearch = compileSearch(data, t);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional, t } = this.props;
    const { advantages } = parseSearch(search, t);
    const variants = getVariants(t);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={advantages.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  toggleExpand() {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  }

  render() {
    const { className, additional, search, isCottegePage, t } = this.props;
    const { advantages } = parseSearch(search, t);
    const isAdvatagesDefiend = checkIsOnePropDefined(advantages);
    const { isExpanded } = this.state;
    const selectedCount = countDefinedProps(advantages);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <div className={styles.Header} onClick={this.toggleExpand}>
          <span className={styles.Title}>
            {t('components.header.filtersBar.filters.advantages.title')}
            {selectedCount > 0 && ` (${selectedCount})`}
            <AngleDown className={cn(styles.Icon, { [styles.Active]: isExpanded })} />
          </span>
          {additional && isAdvatagesDefiend && (
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.advantages.clear')}
            </Button>
          )}
        </div>
        {isExpanded && (
          <div>
            {isCottegePage ? (
              <div className={styles.Checkboxes}>
                <div className={styles.FirstColumn}>
                  {this.checkbox('spa')}
                  {this.checkbox('chldrn')}
                  {this.checkbox('cncrg')}
                  {this.checkbox('nw')}
                  {this.checkbox('walk')}
                  {this.checkbox('roof')}
                </div>
                <div className={styles.SecondColumn}>
                  {this.checkbox('pool')}
                  {this.checkbox('zbbq')}
                  {this.checkbox('kpp')}
                  {this.checkbox('wlns')}
                  {this.checkbox('rstrnt')}
                </div>
                <div className={styles.ThirdColumn}>
                  {this.checkbox('cctv')}
                  {this.checkbox('commerc')}
                  {this.checkbox('elvtr')}
                  {this.checkbox('beach')}
                  {this.checkbox('sport')}
                </div>
              </div>
            ) : (
              <div className={styles.Checkboxes}>
                <div className={styles.FirstColumn}>
                  {this.checkbox('spa')}
                  {this.checkbox('chldrn')}
                  {this.checkbox('cncrg')}
                  {this.checkbox('nw')}
                  {this.checkbox('walk')}
                  {this.checkbox('roof')}
                </div>
                <div className={styles.SecondColumn}>
                  {this.checkbox('pool')}
                  {this.checkbox('zbbq')}
                  {this.checkbox('kpp')}
                  {this.checkbox('wlns')}
                  {this.checkbox('rstrnt')}
                </div>
                <div className={styles.ThirdColumn}>
                  {this.checkbox('cctv')}
                  {this.checkbox('commerc')}
                  {this.checkbox('elvtr')}
                  {this.checkbox('beach')}
                  {this.checkbox('sport')}
                </div>
              </div>
            )}
          </div>
        )}
        {/* {additional ? (
          <div className={styles.ButtonWrap}>
            {isAdvatagesDefiend &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.advantages.clear')}
              </Button>}
          </div>
        ) : (null)} */}
      </div>
    );
  }
}

export default withTranslation()(Advantages);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Advantages/Advantages.js